<template>
	<div class="userpage" :class="($store.state.mode === 'dark') ? 'userpage-dark' : 'false'">
		<div class="navbar" :class="($store.state.mode === 'dark') ? 'dark-header-active' : 'false'">
			<i v-on:click="$router.go(-1)" class="material-icons">arrow_back</i>
			<div class="title">
				Version Beta 0.8.3
			</div>
			<i v-on:click="$router.push('/Support')" class="material-icons">help</i>
		</div>
		<div class="submenu--wrapper">
			<div class="head">	
				<div class="title">
					What's new <span class="dot"></span>
				</div>
				<span class="desc">Last updated Jul 7, 2020</span>
			</div>
			<div class="body-content">
				<div class="sub-title">
					<div class="features"><span class="dot"></span> Fix duplicate css</div>
					<div class="features"><span class="dot"></span> Fix sufficent color contrast</div>
					<div class="features"><span class="dot"></span> Reformat image</div>
					<div class="features"><span class="dot"></span> Remove unnesessary chunk</div>
				</div>
			</div>
			<div class="body-content">
				<div class="title">
					More update coming soon!
				</div>
				<span class="desc">Future release will be out of Beta!</span>
			</div>
			<div class="body-content" @click="openURL('mailto:kyangbesar@gmail.com')">
				<div class="title">
					Found bug?
				</div>
				<span class="desc">Contact us at <u>kyangbesar@gmail.com</u></span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			mode: null,
		}
	},
	methods: {
		openURL: function(url) {
			window.open(url,'_blank')
		}
	},
	mounted() {
		this.mode = localStorage.mode
	},
};
</script>